// List of all possible logos with their titles and subtitles
const logos = [
    { src: '/images/logos/The-OSINT-Newsletter.webp', title: 'The OSINT Newsletter', subtitle: 'by Jake Creps' },
    { src: '/images/logos/Sector035.webp', title: 'The Week in OSINT', subtitle: 'by Sector035' },
    { src: '/images/logos/OSINT-Techniques.webp', title: 'Forensic OSINT', subtitle: 'by Ritu Gill' },
    { src: '/images/logos/GIJN.webp', title: 'GIJN', subtitle: 'Journalism Network' },
    { src: '/images/logos/Digital-Investigations.webp', title: 'Digital Investigations', subtitle: 'by Craig Silverman' },
    { src: '/images/logos/osintme.webp', title: 'OSINT Me', subtitle: 'by Maciej Makowski' }
];

// Function to get a random index
function getRandomIndex(excludeIndices) {
    let index;
    do {
        index = Math.floor(Math.random() * logos.length);
    } while (excludeIndices.includes(index));
    return index;
}

// Function to update a specific logo block with a random logo
function updateLogo(logoBlock, excludeIndices) {
    const logoImg = logoBlock.querySelector('img');
    const logoTitle = logoBlock.querySelector('.logo-title');
    const logoSubtitle = logoBlock.querySelector('.logo-subtitle');

    const newIndex = getRandomIndex(excludeIndices);
    const newLogo = logos[newIndex];

    logoImg.src = newLogo.src;
    logoImg.alt = newLogo.title;
    logoTitle.textContent = newLogo.title;
    logoSubtitle.textContent = newLogo.subtitle;

    return newIndex;
}

// Function to get visible logo blocks
function getVisibleLogoBlocks() {
    const logoBlocks = document.querySelectorAll('.logo-block');
    return Array.from(logoBlocks).filter(block => getComputedStyle(block).display !== 'none');
}

// Function to initialize logos and then shuffle them at a steady interval
function shuffleLogos() {
    let currentIndices = [];

    function initializeLogos() {
        const visibleBlocks = getVisibleLogoBlocks();
        currentIndices = [];

        // Initialize logos with unique logos
        visibleBlocks.forEach((block, i) => {
            const newIndex = getRandomIndex(currentIndices);
            currentIndices.push(updateLogo(block, currentIndices));
        });
    }

    // Initialize logos initially
    initializeLogos();

    // Start shuffling at a steady interval of 2 seconds
    setInterval(() => {
        const visibleBlocks = getVisibleLogoBlocks();
        if (visibleBlocks.length === 0) return; // No visible blocks to update

        const randomBlockIndex = Math.floor(Math.random() * visibleBlocks.length);
        const excludeIndices = currentIndices.filter((_, idx) => idx !== randomBlockIndex);
        const newIndex = updateLogo(visibleBlocks[randomBlockIndex], excludeIndices);

        // Update the currentIndices array with the new logo index
        currentIndices[randomBlockIndex] = newIndex;
    }, 2000); // Steady interval of 2 seconds

    // Update logos when the window is resized
    window.addEventListener('resize', initializeLogos);
}

// Execute the script as soon as the page loads
window.addEventListener('DOMContentLoaded', shuffleLogos);